import React from "react";
import { Link } from "react-router-dom";
import Seo from "../Seo/Seo";
import "./NotFound.scss";

function NotFound() {
  return (
    <main className="not-found-page page-top-settings" aria-labelledby="not-found-heading">
      <Seo
        title="Page Not Found | Klean Leaf"
        description="The requested Klean Leaf page could not be found."
        path="/404"
        robots="noindex, follow"
      />
      <section className="not-found-content">
        <span className="not-found-eyebrow">404</span>
        <h1 id="not-found-heading">Page not found</h1>
        <p>
          This page may have moved, or the address may be incorrect. You can return to the
          Klean Leaf site and continue exploring private label laundry sheet support.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="not-found-primary">Go Home</Link>
          <Link to="/blog" className="not-found-secondary">Read the Blog</Link>
        </div>
      </section>
    </main>
  );
}

export default NotFound;
